/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Schedule_Frequency_WeeklyInputs */



/**
* | output |
* | --- |
* | "Every week" |
*
* @param {Agent_Schedule_Frequency_WeeklyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_schedule_frequency_weekly = /** @type {((inputs?: Agent_Schedule_Frequency_WeeklyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Schedule_Frequency_WeeklyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Wöchentlich")
	return /** @type {LocalizedString} */ ("Every week")
});